export default {"ScrollAreaRoot":"ScrollView-module__ScrollAreaRoot__L0Dd4","ScrollAreaViewport":"ScrollView-module__ScrollAreaViewport__R9XUI"};